import React, {useImperativeHandle, forwardRef} from "react";
import PropTypes from "prop-types";
import InputGroup from "../../../forms/components/InputGroup/InputGroup";
import {DecisionStep, SequenceStep} from "../../models/Step";
import {withNamespaces} from "react-i18next";

const SequenceComponent = (props) => {
  return (
    <div>
      {props.children}
    </div>
  );
};
SequenceComponent.propTypes = {
  children: PropTypes.node,
  step: PropTypes.object.isRequired,
  onChange: PropTypes.func,
};

export const DecisionComponent = withNamespaces()((props) => {
  return (
    <div>
      {props.step.options.map(option => (
        <InputGroup id={option.name} label={option.name} key={option.name}>
          <div className='radio'>
            <input type="radio" name={option.name} id={option.name} onChange={() => props.onStepSelect(option)} checked={!!(props.selectedStep && props.selectedStep.name === option.name)}/>
            <label htmlFor={option.name}>{props.t(option.name)}</label>
          </div>
        </InputGroup>
      ))}
    </div>
  );
});
DecisionComponent.propTypes = {
  step: PropTypes.object.isRequired,
  selectedStep: PropTypes.object,
  onStepSelect: PropTypes.func,
};


const ProcessComponent = forwardRef((props, ref) => {
  console.log('process component', ref);
  useImperativeHandle(ref, () => ({
    next: () => {
      onNextStepSwitch();
    }
  }))

  const onChange = (data) => {
    console.log('Change', data);
  };

  const onStepSelect = (step) => {
    const currentStep = props.process.getCurrentStep(props.data);
    props.setData({...props.data, [currentStep.name]: step.name});
  }

  const clearStep = (name, wholePass, prevPass = null) => {
    const passedSteps = props.data.passedSteps;
    const currentStepPassedSteps = [...passedSteps[name]];

    if (currentStepPassedSteps.length === 1) {
      const updatePassedSteps = {...passedSteps, wholePass};
      delete updatePassedSteps[name];
      props.setData({...props.data, passedSteps: updatePassedSteps});
    } else {
      currentStepPassedSteps.pop();
      const updatePassedSteps = {...passedSteps, [name]: [...currentStepPassedSteps], wholePass};
      props.setData({...props.data, passedSteps: updatePassedSteps});
    }
  };

  const onPrevStepSwitch = () => {
    const currentStep = props.process.getCurrentStep(props.data);
    const passedSteps = props.data.passedSteps;
    const wholePass = [...passedSteps.wholePass];
    const prevPass = wholePass.pop();

    if (!passedSteps.hasOwnProperty(currentStep.name) || !passedSteps[currentStep.name].includes(prevPass)) {
      clearStep(prevPass, wholePass);
    } else {
      clearStep(currentStep.name, wholePass, prevPass);
    }
  };

  const onNextStepSwitch = () => {
    const currentStep = props.process.getCurrentStep(props.data);
    const currentChild = props.process.getCurrentChild(props.data);

    const stepIsValid = currentStep.isValid(props.data) && (currentStep.name === currentChild.name || currentChild.isValid(props.data.data || {}))

    //need to add onComplete!
    if (stepIsValid) { // can next?
      if (!props.process.isLastStep(props.data)) {
        const pathForCompletion = props.process.getPathForCompletion(props.data);
        // if sequence complete mark as compete
        const passedSteps = props.data.passedSteps || {};
        const wholePass = passedSteps.wholePass || [];
        // for nested need to add parent mark
        const updatePassedSteps = {
          ...passedSteps,
          [currentStep.name]: [...(passedSteps[currentStep.name]||[]), pathForCompletion.name],
          wholePass: [...wholePass, currentStep.name]
        };
        const data = {...props.data, passedSteps: updatePassedSteps};
        props.setData(data);
      } else {
        props.onComplete();
      }
    } else {
      const error = currentStep.getErrors();
      console.warn('Invalid data', error);
    }
  };

  const canNext = () => {
    const currentStep = props.process.getCurrentStep(props.data);
    const currentChild = props.process.getCurrentChild(props.data);

    return !props.process.isLastStep(props.data) && currentStep.isValid(props.data) && (currentStep.name === currentChild.name || currentChild.isValid(props.data.data || {}))
  }

  const canPrev = () => {
    return props.data.passedSteps && props.data.passedSteps.wholePass && props.data.passedSteps.wholePass.length > 0;
  };

  const setStepsData = (data) => {
    props.setData({...props.data, data: data})
  }

  const renderComponent = () => {
    const currentStep = props.process.getCurrentStep(props.data);
    const currentChild = props.process.getCurrentChild(props.data);
    if (currentStep instanceof SequenceStep) {
      const Component = currentChild.component;
      return (
        <SequenceComponent step={currentStep} onChange={onChange} data={props.data.data || {}} setData={setStepsData}>
          <Component data={props.data.data || {}} setData={setStepsData} />
        </SequenceComponent>
      );
    } else if (currentStep instanceof DecisionStep) { //need to align selected and passed child
      const Component = currentChild.component || DecisionComponent;
      return <Component step={currentStep}
                        selectedStep={props.process.getPathForCompletion(props.data)}
                        onStepSelect={onStepSelect}
                        data={props.data.data || {}}
                        setData={setStepsData}/>;
    } else {
      throw new Error(`Component not found for step ${currentStep.name}`);
    }
  }

  return (
    <div>
      {renderComponent()}
      <div className='process-buttons'>
        {props.backText && (
          <button className='form-main-button white-with-border no-border back-button' onClick={onPrevStepSwitch} disabled={!canPrev()}>
            <i className='fa fa-chevron-left' />
            {props.backText}
          </button>
        )}
        {props.nextText && (
          <button className='form-main-button white-with-border next-button' onClick={onNextStepSwitch} disabled={!canNext()}>
            {props.nextText}
          </button>
        )}
        {props.buttons}
      </div>
    </div>
  );
});

ProcessComponent.propTypes = {
  process: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  setData: PropTypes.func.isRequired,
  buttons: PropTypes.node,
  onComplete: PropTypes.func,
  backText: PropTypes.string,
  nextText: PropTypes.string,
};

export const StepProps = {
  data: PropTypes.object,
  setData: PropTypes.func,
}

export default (ProcessComponent);